export enum Icons {
  days = "\ue900",
  about = "\ue901",
  accept = "\ue902",
  account = "\ue903",
  account_policies = "\ue904",
  Add_User = "\ue905",
  add_tags = "\ue906",
  adresses = "\ue907",
  advanced_search = "\ue908",
  agenda = "\ue909",
  agenda_both = "\ue90a",
  agenda_forward = "\ue90b",
  agenda_mail = "\ue90c",
  agenda_no_day = "\ue90d",
  agenda_reply = "\ue90e",
  agenda_unread = "\ue90f",
  allieses = "\ue910",
  archive = "\ue911",
  attachment_small = "\ue912",
  attachment = "\ue913",
  attachment_history = "\ue914",
  backup = "\ue915",
  badge = "\ue916",
  bcc_all_mesages = "\ue917",
  bday = "\ue918",
  bold = "\ue919",
  both = "\ue91a",
  business = "\ue91b",
  business_card = "\ue91c",
  caldav = "\ue91d",
  calendar = "\ue91e",
  cards = "\ue91f",
  category = "\ue920",
  center_align = "\ue921",
  clean = "\ue922",
  clock = "\ue923",
  close = "\ue924",
  cloud_storage = "\ue925",
  color = "\ue926",
  communication_history = "\ue927",
  company = "\ue928",
  completed = "\ue929",
  confirmation = "\ue92a",
  contact_presence = "\ue92b",
  copy = "\ue92c",
  copy_format = "\ue92d",
  copy_to_folder = "\ue92e",
  crash = "\ue92f",
  create_event = "\ue930",
  create_task = "\ue931",
  cross = "\ue932",
  custom_view = "\ue933",
  customize = "\ue934",
  cut = "\ue935",
  day = "\ue936",
  details = "\ue937",
  dismiss = "\ue938",
  display_as = "\ue939",
  distribution_list = "\ue93a",
  dont_encrypt = "\ue93b",
  dont_save_key = "\ue93c",
  dont_share_public_key = "\ue93d",
  dots = "\ue93e",
  doublearrow_down = "\ue93f",
  doublearrow_up = "\ue940",
  down = "\ue941",
  down2 = "\ue942",
  drop_glyph_arrow = "\ue943",
  edit = "\ue944",
  em_ox = "\ue945",
  encrypt = "\ue946",
  encrypt_small = "\ue947",
  encryption = "\ue948",
  error = "\ue949",
  error_outline = "\ue94a",
  exchange = "\ue94b",
  existing_import = "\ue94c",
  faces = "\ue94d",
  failed = "\ue94e",
  faq = "\ue94f",
  favorites = "\ue950",
  fb_arrow = "\ue951",
  fb_home = "\ue952",
  flag = "\ue953",
  flag2 = "\ue954",
  flag2_cross = "\ue955",
  flags = "\ue956",
  folder = "\ue957",
  folder_inbox = "\ue958",
  folder_junk = "\ue959",
  folder_more = "\ue95a",
  folder_open = "\ue95b",
  folder_outbox = "\ue95c",
  folder_sent = "\ue95d",
  folder_snooze = "\ue95e",
  folder_trash = "\ue95f",
  folder_unread = "\ue960",
  folder_user = "\ue961",
  font = "\ue962",
  food = "\ue963",
  form_touch = "\ue964",
  forward = "\ue965",
  forward_as_attachment = "\ue966",
  forward_as_original = "\ue967",
  general = "\ue968",
  get_support = "\ue969",
  gifs = "\ue96a",
  header_footer = "\ue96b",
  hide_completed = "\ue96c",
  hide_past = "\ue96d",
  history = "\ue96e",
  chat = "\ue96f",
  imap = "\ue970",
  importance = "\ue971",
  incoming_file = "\ue972",
  indent = "\ue973",
  info = "\ue974",
  info2 = "\ue975",
  info3 = "\ue976",
  italic = "\ue977",
  junk = "\ue978",
  justify = "\ue979",
  keybook = "\ue97a",
  languange = "\ue97b",
  layout = "\ue97c",
  left_align = "\ue97d",
  left_bar = "\ue97e",
  left_to_right = "\ue97f",
  left_to_right2 = "\ue980",
  less = "\ue981",
  link = "\ue982",
  list_circle = "\ue983",
  list_decimal = "\ue984",
  list_disc = "\ue985",
  list_lowerlatin = "\ue986",
  list_lowerroman = "\ue987",
  list_square = "\ue988",
  list_upperlatin = "\ue989",
  list_upperroman = "\ue98a",
  list1 = "\ue98b",
  list2 = "\ue98c",
  list3 = "\ue98d",
  location = "\ue98e",
  location_small = "\ue98f",
  logging = "\ue990",
  mail = "\ue991",
  mail_incoming = "\ue992",
  mail_outgoing = "\ue993",
  mark = "\ue994",
  maybe = "\ue995",
  message_format = "\ue996",
  minical = "\ue997",
  move = "\ue998",
  move_to_folder = "\ue999",
  move_to_inbox = "\ue99a",
  multi_instance = "\ue99b",
  nature = "\ue99c",
  new_email = "\ue99d",
  new_plus = "\ue99e",
  new_contact = "\ue99f",
  note = "\ue9a0",
  numbered_list = "\ue9a1",
  objects = "\ue9a2",
  online_meeting = "\ue9a3",
  outdent = "\ue9a4",
  page_setup = "\ue9a5",
  password = "\ue9a6",
  paste = "\ue9a7",
  paste_as_quote = "\ue9a8",
  phone = "\ue9a9",
  phone_list = "\ue9aa",
  phone_outline = "\ue9ab",
  picture = "\ue9ac",
  pin = "\ue9ad",
  play_sound = "\ue9ae",
  pop3 = "\ue9af",
  popup = "\ue9b0",
  popup_off = "\ue9b1",
  presence = "\ue9b2",
  previous = "\ue9b3",
  print = "\ue9b4",
  privacy_policy = "\ue9b5",
  protection = "\ue9b6",
  protocolo = "\ue9b7",
  quicktext = "\ue9b8",
  read = "\ue9b9",
  read2 = "\ue9ba",
  receipt_delivery = "\ue9bb",
  receipt_read = "\ue9bc",
  redo = "\ue9bd",
  refresh = "\ue9be",
  rejected = "\ue9bf",
  release_history = "\ue9c0",
  reminder = "\ue9c1",
  reorder = "\ue9c2",
  repeat = "\ue9c3",
  repeat_overridden = "\ue9c4",
  repeat_small = "\ue9c5",
  reply_all = "\ue9c6",
  reply_conv = "\ue9c7",
  right_align = "\ue9c8",
  right_to_left = "\ue9c9",
  save = "\ue9ca",
  save_file = "\ue9cb",
  save_file_x = "\ue9cc",
  save_public_key = "\ue9cd",
  search = "\ue9ce",
  search_attachments = "\ue9cf",
  send = "\ue9d0",
  send_logs = "\ue9d1",
  services = "\ue9d2",
  setting = "\ue9d3",
  settings = "\ue9d4",
  share = "\ue9d5",
  share_public_key = "\ue9d6",
  shorcut = "\ue9d7",
  sign = "\ue9d8",
  signature = "\ue9d9",
  signature2 = "\ue9da",
  smile = "\ue9db",
  smtp = "\ue9dc",
  snooze = "\ue9dd",
  spellcheck = "\ue9de",
  spellcheck_language = "\ue9df",
  sport = "\ue9e0",
  star = "\ue9e1",
  star_outline = "\ue9e2",
  stickers = "\ue9e3",
  storeage = "\ue9e4",
  style = "\ue9e5",
  swipe_left = "\ue9e6",
  swipe_right = "\ue9e7",
  symbol = "\ue9e8",
  symbols = "\ue9e9",
  table = "\ue9ea",
  tag = "\ue9eb",
  tag_outline = "\ue9ec",
  task = "\ue9ed",
  tenative = "\ue9ee",
  term_of_use = "\ue9ef",
  textline = "\ue9f0",
  themes = "\ue9f1",
  tick = "\ue9f2",
  today = "\ue9f3",
  toolbar = "\ue9f4",
  translate = "\ue9f5",
  trash = "\ue9f6",
  travel = "\ue9f7",
  underline = "\ue9f8",
  undo = "\ue9f9",
  unknown = "\ue9fa",
  unpin = "\ue9fb",
  unread = "\ue9fc",
  up = "\ue9fd",
  up2 = "\ue9fe",
  user = "\ue9ff",
  users = "\uea00",
  warning = "\uea01",
  week = "\uea02",
  widget = "\uea03",
  work_week = "\uea04",
  xmpp = "\uea05",
  zoom_in = "\uea06",
  zoom_out = "\uea07",
  resend = "\uea08",
  flag3 = "\uea09",
  next = "\uea0a",
  filter = "\uea0b",
  bright_state = "\uea0c",
  night_state = "\uea0d",
  contacts = "\uea0e",
  delete = "\uea0f",
}
